import Channel from './channel';

import { delay } from './promisify';




export default function immortal(connectFn, reconnectAttemptCount, reconnectAttemptDelay, reconnectTimeout) {
    return new Channel( writeFn => {
        reconnect();

        function makeAttempts(attemptsLeft) {
            if (!attemptsLeft )
                return Promise.reject();

            return connectFn()
                .then( ch => {
                    ch.forEach( message => writeFn( message ) );
                    ch.end( () => reconnect() );
                } )
                .catch( e => {
                    if (attemptsLeft > 1)
                        return attemptsLeft--,
                            console.log( `${attemptsLeft} attempt(s) left, waiting for ${Math.floor( reconnectAttemptDelay / 1000 )} secs.` ), 
                            delay( reconnectAttemptDelay ).then( () => makeAttempts( attemptsLeft ) );

                    throw e;
                } );
        }

        function reconnect() {
            return makeAttempts( reconnectAttemptCount )
                .catch( () => { 
                    console.log( `${reconnectAttemptCount} attempts failed, next attempt in ${Math.floor( reconnectTimeout / 1000 )} secs.` ); 
                    return delay( reconnectTimeout ).then( () => reconnect() ); 
                } );
        }
    } );
}


// WEBPACK FOOTER //
// ./src/js/utils/immortal.js